import React from 'react'
import { CollectionTable } from '..'

const Publications = props => (
  <CollectionTable type="publication" history={props.history} />
)

export default Publications
